// extracted by mini-css-extract-plugin
export default {"root":"LanguageSwitcherButtons_root__lqBkm","button":"LanguageSwitcherButtons_button__z13XX","active":"LanguageSwitcherButtons_active__XG-VY"};